if (!customElements.get('bf-benefits-carousel')) {
  class BfBenefitsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bf-benefits__track');
      this.slides = Array.from(this.querySelectorAll('.bf-benefits__slide'));
      this.prevButton = this.querySelector('.bf-benefits__prev');
      this.nextButton = this.querySelector('.bf-benefits__next');
      this.dots = Array.from(this.querySelectorAll('.bf-benefits__dot'));
      this.index = 0;

      this.onPrev = () => this.go(this.index - 1);
      this.onNext = () => this.go(this.index + 1);
      this.onResize = () => this.update(false);
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.go(index));
      });
      window.addEventListener('resize', this.onResize);

      this.touchStartX = 0;
      this.onTouchStart = (event) => {
        this.touchStartX = event.touches[0].clientX;
      };
      this.onTouchEnd = (event) => {
        if (this.perView !== 1) return;
        const delta = event.changedTouches[0].clientX - this.touchStartX;
        if (Math.abs(delta) < 40) return;
        this.go(this.index + (delta < 0 ? 1 : -1));
      };
      this.track?.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.track?.addEventListener('touchend', this.onTouchEnd, { passive: true });

      this.update(false);
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
      this.track?.removeEventListener('touchstart', this.onTouchStart);
      this.track?.removeEventListener('touchend', this.onTouchEnd);
    }

    get perView() {
      return window.matchMedia('(min-width: 990px)').matches ? 3 : 1;
    }

    get maxIndex() {
      return Math.max(0, this.slides.length - this.perView);
    }

    go(index) {
      const max = this.maxIndex;
      if (index > max) index = max;
      if (index < 0) index = 0;
      this.index = index;
      this.update(true);
    }

    update(animate) {
      if (!this.track || !this.slides.length) return;
      if (this.index > this.maxIndex) this.index = this.maxIndex;

      const slide = this.slides[0];
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const offset = (slide.getBoundingClientRect().width + gap) * this.index;

      this.track.style.transition = animate ? '' : 'none';
      this.track.style.transform = 'translateX(-' + offset + 'px)';

      const atStart = this.index <= 0;
      const atEnd = this.index >= this.maxIndex;

      if (this.prevButton) {
        this.prevButton.disabled = atStart;
      }

      if (this.nextButton) {
        this.nextButton.disabled = atEnd;
      }

      this.slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.index);
      });

      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('bf-benefits-carousel', BfBenefitsCarousel);
}
